import {appUrl} from '@frontend/AppUrl'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'

// Создание ссылки на объявление.
// Позже, вероятно, добавится аргумент slug для SEO.
export function makeAdUrl(advertisementId: number, queryArgs?: AnyObject): string {
    return NavigationService.makeUrl(
        appUrl().ads.details,
        {id: advertisementId},
        queryArgs
    )
}
